<template>
  <MainNavbar class="bg-transparent fixed-top border-bottom" mwClass="" className="m-auto" />
  <div class="testimonial-page pt-227 pb-100" v-if="member">
    <div class="pb-100">
      <div class="container">
        <div class="section-title mw-600">
          <span class="top-title">Our Celebrities</span>
          <h2>Exclusively shining with us — only on MyCelebrity.</h2>
        </div>
        <div class="row align-items-center">
          <div class="col-lg-4">
            <div class="testimonial-img position-relative mb-4 mb-lg-0 d-inline-block">
              <img :src="`http://localhost:5001/api/team/${member.id}/image`" :alt="member.name" class="testimonial-img" />
            </div>
          </div>
          <div class="col-lg-8">
            <div class="testimonial-quot">
              <p>{{ member.testimonial }}</p>
              <div class="testimonial-info ms-0 text-start">
                <h3>{{ member.name }}</h3>
                <span>{{ member.designation }}</span>
                <div class="testimonial-actions">
                  <router-link to="/get-your-wish" class="testimonial-btn">Get your wish</router-link>
                  <router-link to="/business-enquiry" class="testimonial-btn">Business Enquiry</router-link>
                  <div style="flex-grow: 1;"></div>
                  <a href="https://play.google.com/store/apps/details?id=com.mycelebrity.app" target="_blank" rel="noopener noreferrer" class="testimonial-btn play-store-btn">Download App on Play Store</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else class="testimonial-page pt-227 pb-100">
    <p>Loading...</p>
  </div>
  <MainFooter />

</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";
import { useRoute } from "vue-router";
import MainNavbar from "../components/Layouts/MainNavbar.vue";
import MainFooter from "../components/Layouts/MainFooter.vue";

export default defineComponent({
  name: "TestimonialPage",
  components: { MainNavbar, MainFooter },
  setup() {
    const route = useRoute();
    const member = ref(null);

    const fetchMember = async () => {
      const res = await fetch("http://localhost:5001/api/team");
      const data = await res.json();
      member.value = data.find((m: any) => m.id === Number(route.params.id));
    };

    onMounted(fetchMember);
    return { member };
  },
});
</script>

<style scoped>
.testimonial-actions {
  margin-top: 16px;
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.testimonial-btn {
  background: #f66122ff;
  color: #fff;
  padding: 8px 18px;
  border-radius: 20px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  text-decoration: none;
  font-weight: bold;
  text-align: center;
  transition: background 0.2s;
  font-size: 15px;
}
.testimonial-btn:hover {
  background: #c33e04ff;
  }
.testimonial-page {
  padding: 100px 20px 20px 20px;
}
.pb-100 {
  padding-top: 100px;
}
.section-title.mw-600 {
  max-width: 600px;
  margin: 0 auto 40px auto;
  text-align: center;
}
.testimonial-img img {
  width: 100%;
  max-width: 300px;
  border-radius: 20px;
  box-shadow: 0 8px 32px rgba(0,0,0,0.08);
}
.testimonial-quot {
  margin-left: 64px;
}
.testimonial-quot p {
  font-weight: 500;
  line-height: 30px;
  font-size: 18px;
  color: #4c4c4c;
  font-style: italic;
  margin-bottom: 40px;
}
.testimonial-info h3 {
  font-size: 22px;
  margin-bottom: 5px;
}
.testimonial-info span {
  font-size: 16px;
  color: #888;
}
@media only screen and (max-width: 991px) {
  .testimonial-quot {
    margin-left: 0;
  }
}
</style> 